import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListBanners from './ListBanners';

export default function AdmBanners() {
    return (
        <Routes>
            <Route path="" element={<ListBanners />} />
        </Routes>
    );
}
